"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SAPPropertiesFactoryFromJS = exports.SAPPropertiesFactory = void 0;
const immutable_1 = require("immutable");
const ISAP_1 = require("../credentials/ISAP");
exports.SAPPropertiesFactory = (0, immutable_1.Record)({
    credentials: (0, ISAP_1.SAPCredentialsFactory)(),
    client: '',
    connectionType: 1 /* ESAPConnectionType.Agent */,
    host: '',
    service: '',
    group: '',
    language: '',
    remoteAgentAddress: '',
    systemNumber: '',
    timeout: 60000
});
const SAPPropertiesFactoryFromJS = function (data) {
    return (0, exports.SAPPropertiesFactory)({
        credentials: (0, ISAP_1.SAPCredentialsFactoryFromJS)(data.credentials),
        client: data.client,
        connectionType: data.connectionType,
        host: data.host,
        service: data.service,
        group: data.group,
        language: data.language,
        remoteAgentAddress: data.remoteAgentAddress,
        systemNumber: data.systemNumber
    });
};
exports.SAPPropertiesFactoryFromJS = SAPPropertiesFactoryFromJS;
//# sourceMappingURL=ISAP.js.map